export default {
  namespaced: true,
  state: {
    currentPage: 1,
    pageSize: 15,
    count: 0,
    commentsPage: 1,
    commentsCount: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', { basePath: `api/${params.basePath}/${params.id}/attachments`, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.page = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, params) {
      return dispatch('save', { basePath: `api/${params.basePath}/${params.id}/attachments`, data: params.formData }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async delete ({ dispatch, state }, params) {
      return dispatch('delete', { basePath: `api/attachments`, id: params }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async download ({ dispatch, state }, params) {
      return dispatch('downloadFiles', { url: `api/attachments/${params}/download` }, { root: true })
        .then(response => { return '' })
        .catch(error => { throw error })
    },
    async base64 ({ dispatch, state }, params) {
      return dispatch('request', { method: 'get', url: `api/attachments/${params}/base64` }, { root: true })
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async zip ({ dispatch, state }, params) {
      console.log(params)
      return dispatch('downloadFiles', { url: `api/${params.basePath}/${params.id}/download_zip`, params: params.filters }, { root: true })
        .then(() => { return '' })
        .catch(error => { throw error })
    },
    async mail ({ dispatch, state }, data) {
      return dispatch('save', { basePath: `api/${data.basePath}/${data.id}/send_mail`, data: { recipient: data.mail, is_image: data.is_image } }, { root: true })
        .then(() => { return '' })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/attachments.js